import gql from 'graphql-tag';

// The products that actually have an active master (default coverage)
// subscription seeded - the only products an opt-out can suppress anything on.
// This is deliberately NOT the product catalog (`productMasterQuery`): an
// opt-out naming a product with no master is inert, so the picker offers only
// what is seeded.
const defaultCoverageMasterProductsQuery = gql`
  query GetDefaultCoverageMasterProducts {
    defaultCoverageMasterProducts {
      productId
      productCode
      productName
      masterType
    }
  }
`;

export default defaultCoverageMasterProductsQuery;
